import React, { useState } from 'react';

export default function StepRibbon({ compact = false }) {
  const [open, setOpen] = useState(true);
  if (!open) return null;
  return (
    <div className={`step-ribbon${compact ? ' step-ribbon--compact' : ''}`}>
      <span className="step"><b>1</b> Define an earthquake</span>
      <span className="step-arrow">→</span>
      <span className="step"><b>2</b> Find nearest scenarios</span>
      <span className="step-arrow">→</span>
      <span className="step"><b>3</b> Explore impact</span>
      <button className="steps-close" title="Dismiss" onClick={() => setOpen(false)}>×</button>
    </div>
  );
}
